import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addFavouritesRecipes, getfetchFavouritesRecipes } from "./actions";
import { MessagesType } from "@/utils/types/recipes";

interface FavouritesRecipe {
  favouritesRecipes?: any[];
  isLoading: boolean;
  isError: boolean;
  favourite: string;
}

const initialFavouritesRecipe: FavouritesRecipe = {
  favouritesRecipes: [],
  isLoading: false,
  isError: false,
  favourite: "",
};
const userDietaryPreferences = {
  isLoading: false,
  isError: false,
  detail: "",
};

const initialMessage: MessagesType = {
  LOGIN_MESSAGE: "",
  RECIPE_ADDED_TO_LIST: "",
  RECIPE_REMOVE_TO_LIST: "",
  LIST_NAME_EXIST: "",
  MERGE_SUCCESSFULL: "",
  RECIPE_DELETED: "",
  RECIPE_LIST_DELETED: "",
  RECIPE_LIST_UPDATE: "",
  RECIPE_LIST_CREATE: "",
  FAVOURITE_RECIPE_ADDED: "",
  FAVOURITE_RECIPE_REMOVED: "",
  NO_RECIPE_FOUND: "",
  ADJUST_OPTIONS: "",
  NO_RECIPES_MATCH: "",
  LOGIN_TO_SAVE_RECIPE: "",
  RECIPE_ADDED_WITHOUT_LOGIN: "",
  PERSONAL_NOTE_SAVED: "",
  PERSONAL_NOTE_DELETED: "",
  PERSONAL_NOTE_DELETE_CONFIRM: "",
  ERROR_MESSAGE: {
    INITIAL_SPACE_ERROR: "",
    BEGIN_ERROR_MESSAGE: "",
    END_ERROR_MESSAGE: "",
    LIST_NAME_EMPTY_MESSAGE: "",
    LIST_NAME_MIN_CHARACTERS: "",
    LIST_NAME_MAX_CHARACTERS: "",
    SPECIAL_CHARACTER_NOT_ALLOWED: "",
    RECIPE_LIST_ALREADY_EXIST: "",
    RECIPE_ALREADY_EXIST: "",
    OFFLINE_ERROR: "",
    UNAUTHORIZED: "",
    SERVER_ERROR: "",
    PERSONAL_NOTE_NOT_SAVED: "",
    PERSONAL_NOTE_NOT_DELETED: "",
    PERSONAL_NOTE_TOO_LONG: "",
  },
};

const FavouritesRecipe = createSlice({
  name: "favourites",
  initialState: initialFavouritesRecipe,
  reducers: {
    setFavouritelist: (state, action: PayloadAction<any>) => {
      state.favourite = action.payload;
      state.favouritesRecipes = action.payload.recipes;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getfetchFavouritesRecipes.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      getfetchFavouritesRecipes.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = true;
        state.isError = false;
        state.favouritesRecipes = action?.payload?.data?.recipes;
        state.favourite = action?.payload?.data;
      }
    );
    builder.addCase(getfetchFavouritesRecipes.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });

    builder.addCase(
      addFavouritesRecipes.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = true;
        state.isError = false;
      }
    );
  },
});

const SetPreferences = createSlice({
  name: "preferences",
  initialState: userDietaryPreferences,
  reducers: {},
  extraReducers: (builder) => {
    // builder.addCase(
    //   setPreferences.pending,
    //   (state, action: PayloadAction<any>) => {
    //     state.isLoading = true;
    //     state.isError = false;
    //   }
    // );
    // builder.addCase(
    //   setPreferences.fulfilled,
    //   (state, action: PayloadAction<any>) => {
    //     state.isLoading = true;
    //     state.isError = false;
    //     state.detail = action.payload.detail;
    //   }
    // );
    // builder.addCase(setPreferences.rejected, (state) => {
    //   state.isLoading = false;
    //   state.isError = true;
    // });
  },
});

const messages = createSlice({
  name: "Messages",
  initialState: {
    messages: initialMessage,
    sortLabel: "Alphabetical" as string | null,
    canClearTimeFilter: false,
  },
  reducers: {
    setMessages(state: any, action: PayloadAction<any>) {
      const {
        beginErrorMessage,
        endErrorMessage,
        initialSpaceError,
        listNameEmptyMessage,
        listNameExist,
        listNameMaxChar,
        listNameMinChar,
        loginMessage,
        recipeDeleted,
        recipeListAlreadyExist,
        recipeListCreate,
        recipeListDeleted,
        recipeListMerge,
        recipeListUpdate,
        recipeSuccessfulAdd,
        recipeSuccessfulRemoval,
        specialCharNotAllowed,
        recipeAlreadyExists,
        favouriteRecipeAdded,
        favouriteRecipeRemoved,
        noRecipeFound,
        adjustOptions,
        noRecipesMatch,
        loginToSaveRecipe,
        recipesAddedWithoutLogin,
        personalNoteSaved,
        personalNoteDeleted,
        personalNoteNotSaved,
        personalNoteNotDeleted,
        personalNoteTooLong,
        personalNoteConfirm,
        serverError,
        offlineError,
      } = action.payload;

      const message = {
        LOGIN_MESSAGE: loginMessage,
        RECIPE_ADDED_TO_LIST: recipeSuccessfulAdd,
        RECIPE_REMOVE_TO_LIST: recipeSuccessfulRemoval,
        LIST_NAME_EXIST: listNameExist,
        MERGE_SUCCESSFULL: recipeListMerge,
        RECIPE_DELETED: recipeDeleted,
        RECIPE_LIST_DELETED: recipeListDeleted,
        RECIPE_LIST_UPDATE: recipeListUpdate,
        RECIPE_LIST_CREATE: recipeListCreate,
        FAVOURITE_RECIPE_ADDED: favouriteRecipeAdded,
        FAVOURITE_RECIPE_REMOVED: favouriteRecipeRemoved,
        NO_RECIPE_FOUND: noRecipeFound,
        ADJUST_OPTIONS: adjustOptions,
        NO_RECIPES_MATCH: noRecipesMatch,
        LOGIN_TO_SAVE_RECIPE: loginToSaveRecipe,
        RECIPE_ADDED_WITHOUT_LOGIN: recipesAddedWithoutLogin,
        PERSONAL_NOTE_SAVED: personalNoteSaved,
        PERSONAL_NOTE_DELETED: personalNoteDeleted,
        PERSONAL_NOTE_DELETE_CONFIRM: personalNoteConfirm,

        ERROR_MESSAGE: {
          INITIAL_SPACE_ERROR: initialSpaceError,
          BEGIN_ERROR_MESSAGE: beginErrorMessage,
          END_ERROR_MESSAGE: endErrorMessage,
          LIST_NAME_EMPTY_MESSAGE: listNameEmptyMessage,
          LIST_NAME_MIN_CHARACTERS: listNameMinChar,
          LIST_NAME_MAX_CHARACTERS: listNameMaxChar,
          SPECIAL_CHARACTER_NOT_ALLOWED: specialCharNotAllowed,
          RECIPE_LIST_ALREADY_EXIST: recipeListAlreadyExist,
          RECIPE_ALREADY_EXIST: recipeAlreadyExists,
          PERSONAL_NOTE_NOT_SAVED: personalNoteNotSaved,
          PERSONAL_NOTE_NOT_DELETED: personalNoteNotDeleted,
          PERSONAL_NOTE_TOO_LONG: personalNoteTooLong,
          OFFLINE_ERROR: offlineError,
          UNAUTHORIZED: serverError,
        },
      };

      state.messages = message;
    },

    setSortDefault(state: any, action: PayloadAction<string | null>) {
      state.sortLabel = action.payload;
    },
    setClearTotalTime(state: any, action: PayloadAction<boolean>) {
      state.canClearTimeFilter = action.payload;
    },
  },
});

const homepageRecipes = createSlice({
  name: "HomepageRecipes",
  initialState: {
    homepageBanner: {} as any,
    homePageRecipeData: [] as any,
  },
  reducers: {
    setHomepageBanner(state: any, action: PayloadAction<any>) {
      state.homepageBanner = action.payload;
    },

    setHomePageRecipeData(state: any, action: PayloadAction<any>) {
      state.homePageRecipeData = action.payload;
    },
  },
});

export const { setFavouritelist } = FavouritesRecipe.actions;
export const favouritesRecipeSlice = FavouritesRecipe.reducer;

export const preferencesSlice = SetPreferences.reducer;

export const { setMessages, setSortDefault, setClearTotalTime } =
  messages.actions;
export const { setHomepageBanner, setHomePageRecipeData } =
  homepageRecipes.actions;
export const homepageRecipeSlice = homepageRecipes.reducer;

export const messageSlice = messages.reducer;
